var _style, _path, _path2, _path3, _ellipse, _defs, _defs2, _defs3, _defs4, _mask, _defs5, _mask2, _path4, _path5, _path6, _path7, _ellipse2, _defs6, _defs7, _defs8, _defs9, _mask3, _defs10, _mask4, _path8, _defs11, _defs12, _defs13, _defs14, _mask5, _defs15, _mask6, _ellipse3, _path9, _defs16, _defs17, _defs18, _defs19, _mask7, _defs20, _mask8, _path10, _path11, _defs21, _defs22, _defs23, _defs24, _mask9, _defs25, _mask10, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse5, _ellipse6, _path27, _path28, _ellipse7, _ellipse8, _path29, _path30, _ellipse9, _ellipse10, _path31, _path32, _ellipse11, _ellipse12, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse13, _path41, _ellipse14, _path42, _path43, _path44, _ellipse15, _path45, _ellipse16, _path46, _ellipse17, _path47, _ellipse18, _path48, _ellipse19, _path49, _path50, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 486.7"
    },
    viewBox: "0 0 750 486.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#2f5432}.st3{fill:#f1f1f1}.st4{fill:#111a22}.st8{fill:#e79937}.st24{fill:#203830}.st25{opacity:.5;fill:#2f5432;enable-background:new}.st26{fill:#181133}.st27{opacity:.5}")), /*#__PURE__*/React.createElement("path", {
    d: "M591.6 67.4c-5.8-13.4-17.1-23.1-30.2-25.5-7.9-1.5-15.5.1-23.1 3-8 3-15.7 6.8-24.2 7.9-16.2 2.1-32.2-3.5-47.8-7.6-7.7-2.2-15.7-3.8-23.7-4.6-7.6-.6-15.2.1-22.5 2.2-14.2 4.2-26.8 12.8-35.9 24.5h1c.8-.9 1.5-1.8 2.3-2.8 10-11.5 23.5-19.3 38.4-22.3 15.8-3 31.4 1.3 46.7 5.5 14.8 4.1 30.2 8.4 45.5 5.2 8-1.7 15.3-5.6 23-8.2s15.7-3.4 23.6-1.1c11.3 3.3 20.7 12.2 25.8 23.8h1.1zM581.9 90c5.2-5.1 11.2-9.3 17.8-12.3 6.4-2.7 13.3-4.4 20.3-5 15.6-1.4 31.2.9 45.2 8 7.8 4 14.9 9.3 21 15.6.3.4.9-.2.5-.5-11-11.6-25.3-19.5-40.9-22.7-7.7-1.5-15.5-1.9-23.3-1.3-7.1.3-14.1 1.8-20.7 4.3-7.6 3-14.5 7.6-20.3 13.3-.4.3.1.8.4.6zM107.7 326.5c8.8-10.5 21.8-16.8 35-19.4 14.3-2.8 29.2-1.1 42.6 4.8 6.9 3 13.2 7.5 18.4 13 .3.4.9-.2.5-.5-9.5-10.3-23.1-16.4-36.8-18.5-14.4-2.3-29.2 0-42.3 6.4-6.8 3.3-12.9 8-17.9 13.7-.3.3.2.9.5.5zm351.8-52.7c11.2 20.1 37 29.9 58.8 22.4 6.7-2.3 13-5.8 19.7-8.1 7.4-2.5 15.3-3.1 23-1.9 15.4 2.1 30.2 9 45.9 8.2 12.7-.6 27.1-8.2 29-22 .1-.5-.7-.7-.7-.2-1.7 12.3-13.9 19.9-25.4 21.2-15.5 1.8-30.3-4.8-45.3-7.5-7-1.2-14.3-1.7-21.3-.2-6.7 1.5-12.9 4.6-19.1 7.3-5.8 2.5-11.7 4.4-18.1 4.8-5.5.3-11.1-.3-16.5-1.8-12.2-3.5-23.2-11.5-29.4-22.7-.2-.2-.9.2-.6.5zm280.4-70.7c5.3 11.7 2.3 25.5-7.4 34-5.4 4.6-12.1 7.3-19.2 7.7l-.3.8c1.6-.1 3.3-.3 4.9-.7 13.5-2.7 23.5-13.1 25.2-25.8 1.3-9.3-2.3-19.1-9.1-26.5l-.3.8c2.6 2.9 4.7 6.1 6.2 9.7zM340.3 390.7h-1.2c-4.5 4.7-9.4 8.9-14.8 12.5-17.5 12-37.9 16.8-57.6 13.1-16.8-3.1-32.8-12.1-45.9-25.6h-1.2c6.4 6.8 13.8 12.6 21.9 17.2 18.3 10.4 39 13.3 58.7 7.7 14.8-4.1 28.6-12.7 40.1-24.9zm13.2 1.8c9.2 12.1 22.6 20.3 37.6 23.1 23.5 4 47.1-6 60.5-25.6.3-.4-.4-.8-.6-.4-8.3 12.1-20.8 20.8-35 24.4-23.1 5.6-47.4-3-61.8-21.9-.3-.4-.9 0-.7.4zM39.4 350.6c1.9 1.6 3.1 3.7 3.6 6.1 2.2 9.4-2.2 21.5 5.6 28.1 6.8 5.7 19.2 4.9 29.8-1.5l-.4-.6c-5.5 3.3-11.7 5.2-17.2 5.2-7 0-12.6-3.3-14.8-8.4-3.4-8.1 1.1-19.6-3.5-27.1-2.3-3.7-6.8-5.1-11.9-5.7-5.8-.7-11.5-1.2-16-3.9-8.4-5-11.9-15-8.1-25.9 2.4-7 7.5-14 14.1-19.8l-.4-.6C12.6 302.9 7 311.1 4.8 319c-2.9 11 1.3 20.7 10.4 25.2 4.8 2.4 10.7 2.6 16.5 3.5 2.7.3 5.4 1.3 7.7 2.9zm125 38.8h-1.1c-2.4 2.7-5 5.2-7.7 7.5-11.1 9.1-23.4 12.8-35.6 10.2-9.9-2.1-19.5-8.2-28-17.7h-1.1c3.8 4.4 8.1 8.4 12.9 11.7 11.7 7.9 24.5 10 36.8 5.7 8.4-3 16.6-9 23.8-17.4zm136.8-305s0-.1-.1-.1c-5-7.4-11.5-13.6-19-18.3-13-8.1-28.3-10.7-42.7-6.8-13.7 3.6-26.1 12.7-34.8 25.3h1c4.5-6.5 10.2-12.1 16.8-16.6 12.6-8.4 27.6-11.6 41.9-8.4 14.1 3.2 27 12.1 36 24.9h.9zm440.6 306.2h-1.1c-2.5 2.9-5.5 5.4-8.8 7.3-7.1 4.3-15.8 5.3-23.7 2.6-5.5-2-10.5-5.4-14.3-9.9h-1.1c1.6 2 3.5 3.7 5.4 5.3 7 5.6 15.4 8 23.6 6.6 8-1.4 15-5.7 20-11.9z",
    style: {
      fill: "#7ec46d"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M750 323.9v69.2H99.7c-12.3 0-24.4-2.7-35.6-8-10.6-5-20.2-12.2-28-20.9-32.7-37.3-32.7-93.1 0-130.4 7.8-8.8 17.4-15.9 28-20.9 11-5.2 23-7.9 35.1-8h551.1c5.8 0 10-3.7 12-5.9 9-11 9-26.9 0-37.9-2-2.2-6.2-5.9-12-5.9L0 155.3V86l650.3-.1c12.3 0 24.4 2.7 35.5 8 10.6 5 20.2 12.2 28 20.9 32.7 37.3 32.7 93.1 0 130.4-7.8 8.8-17.4 15.9-28 20.9-11 5.2-23 7.9-35.1 8h-551c-5.8 0-10 3.7-12 5.9-9 11-9 26.9 0 37.9 2 2.2 6.2 5.9 12 5.9l650.3.1z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M750 328.4v60.3H99.7c-11.6 0-23.1-2.6-33.6-7.5-10.1-4.8-19.1-11.5-26.5-19.9-31.1-35.6-31.1-88.8 0-124.4 7.4-8.3 16.5-15.1 26.5-19.9 10.5-5 22-7.6 33.6-7.6h550.6c7.5 0 12.8-4.6 15.3-7.4 10.6-12.7 10.6-31.2 0-43.9-2.5-2.8-7.8-7.4-15.3-7.4l-650 .1V90.5l650.1-.1c11.6 0 23.1 2.6 33.7 7.6 10.1 4.8 19.1 11.5 26.5 19.9 31.1 35.6 31.1 88.8 0 124.4-7.4 8.3-16.5 15.1-26.5 19.9-10.5 5-22 7.6-33.7 7.6H99.7c-7.6 0-12.9 4.6-15.3 7.4-10.6 12.7-10.6 31.2 0 43.9 2.5 2.8 7.8 7.4 15.3 7.4l650.3-.1z",
    style: {
      fill: "#2a2e47"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 117.9h12.9v5.5H.2v-5.5zm650.1 124.4h-21.5v-5.5h21.5c1.2 0 2.5-.1 3.7-.1l.4 5.5c-1.3 0-2.7.1-4.1.1zm-55.8 0h-25.4v-5.5h25.4v5.5zm-59.7 0h-25.4v-5.5h25.4v5.5zm-59.7 0h-25.4v-5.5h25.4v5.5zm-59.8 0h-25.4v-5.5h25.4v5.5zm-59.7 0h-25.4v-5.5h25.4v5.5zm-59.7 0h-25.4v-5.5h25.4v5.5zm-59.8 0h-25.4v-5.5h25.4v5.5zm-59.7 0H151v-5.5h25.4v5.5zm510.3-14.9-3.8-4c5.9-5.6 10.5-12.4 13.5-19.9l5.1 2.1c-3.3 8.2-8.3 15.7-14.8 21.8zm13.7-56.2c-1.1-8.1-3.8-15.8-8-22.8l4.7-2.8c4.5 7.6 7.5 16.1 8.7 24.9l-5.4.7zM668.5 127c-5.7-2.5-11.9-3.8-18.2-3.8h-5.6v-5.5h5.6c7 0 13.9 1.4 20.4 4.2l-2.2 5.1zm-621.1-3.6v-5.5h25.4v5.5H47.4zm59.8 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5H252v5.5h-25.4zm59.8 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5H491v5.5h-25.5zm59.8 0v-5.5h25.4v5.5h-25.4zm59.7 0v-5.5h25.4v5.5H585zM103.8 236.8h12.9v5.5h-12.9v-5.5z",
    className: "st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m94.1 243.8-1.3-5.3c4.4-1.1 8.9-1.7 13.4-1.7v5.5c-4.1 0-8.2.5-12.1 1.5zm609.1 117.5h-25.3v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5H525v5.5zm-59.5 0h-25.3v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5h25.3v5.5zm-59.4 0H262v-5.5h25.3v5.5zm-59.4 0h-25.3v-5.5h25.3v5.5zm-59.5 0h-25.3v-5.5h25.3v5.5zm-59.4 0h-9.3c-5.6 0-11.2-.9-16.6-2.8l1.8-5.2c4.8 1.6 9.7 2.4 14.8 2.5h9.3v5.5zM55.2 337c-5-7.3-8.5-15.5-10.3-24.1l5.4-1.1c1.6 7.9 4.8 15.4 9.4 22.1l-4.5 3.1zm-2.4-57.2-5.1-2c3.3-8.2 8.3-15.6 14.6-21.8l3.9 3.9c-5.8 5.7-10.4 12.5-13.4 19.9zm684.6 76H750v5.5h-12.6v-5.5zM27.7 438.2s6.1-16.5 16.6-15.8 16.8 8.8 24.6 7.5 9.6-13.4 20.6-14.7 15.2 14.4 22.7 14.7 7.8-8.3 20.3-7.8 18.5 16 18.5 16l-123.3.1zm378 21.9c-4.2-6.8-12.1-21.5-23-20.1s-12.3 10.5-20.1 11.9-14.2-6.7-24.6-7.5-16.6 15.8-16.6 15.8l84.3-.1z",
    className: "st3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.9,
    cy: 98.4,
    className: "st4",
    rx: 27,
    ry: 4.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1 1h1L1 2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M1 1h1L1 2z"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M-1-1h-1l1-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_",
    style: {
      clipPath: "url(#SVGID_5_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 21.4,
    height: 20.7,
    x: 106.7,
    y: 57.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "g_2_",
    width: 21.4,
    height: 20.7,
    x: 106.7,
    y: 57.5,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)",
      mask: "url(#g_2_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    width: 21.4,
    height: 20.7,
    x: 106.7,
    y: 57.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "h_2_",
    width: 21.4,
    height: 20.7,
    x: 106.7,
    y: 57.5,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.2 67.7c0 10.1-4.1 10.5-6.8 10.5s-6.7-.3-6.7-10.7c0-9.6 4.2-10 6.7-10s6.8.5 6.8 10.2zm-7.6 0c0 6 .1 6.5.9 6.5s.8-.7.8-6.5c0-5.5 0-6.1-.8-6.1s-.9.5-.9 6.1zm9.6 10.1V63.3c-.5 0-1-.1-1.5-.3v-3.7c1.2 0 2.4-.5 3.2-1.4h4.2v20l-5.9-.1z",
    style: {
      mask: "url(#h_2_)",
      fill: "#111a22"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9 101.4c0 2.2-8.9 4-19.8 4s-19.8-1.8-19.8-4 8.9-4 19.8-4 19.8 1.8 19.8 4z",
    className: "st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6 62.3c-3-4.4-8.1-8-16.5-8s-13.5 3.5-16.5 8c-5.1 7.5-4.2 17.5 2.1 24.1l14.4 15.2 14.4-15.2c6.3-6.6 7.2-16.6 2.1-24.1zM66.1 82.7c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z",
    className: "st8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.6 342.6c0 2.2-8.9 4-19.8 4s-19.8-1.8-19.8-4 8.9-4 19.8-4 19.8 1.8 19.8 4z",
    className: "st4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.3 303.4c-3-4.4-8.1-8-16.5-8s-13.5 3.5-16.5 8c-5.1 7.5-4.2 17.5 2.1 24.1l14.4 15.2 14.5-15.2c6.2-6.6 7.1-16.6 2-24.1zm-16.5 20.5c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z",
    className: "st8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.9,
    cy: 338.8,
    className: "st4",
    rx: 27,
    ry: 4.9
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M1 1h1L1 2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M1 1h1L1 2z"
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M-1-1h-1l1-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_",
    style: {
      clipPath: "url(#SVGID_11_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    width: 27,
    height: 20.8,
    x: 283.2,
    y: 297.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "g_4_",
    width: 27,
    height: 20.8,
    x: 283.2,
    y: 297.8,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_12_)",
      mask: "url(#g_4_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    width: 27,
    height: 20.8,
    x: 283.2,
    y: 297.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "i_2_",
    width: 27,
    height: 20.8,
    x: 283.2,
    y: 297.8,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.6 308c0 10.1-4.1 10.5-6.8 10.5s-6.6-.3-6.6-10.7c0-9.6 4.2-10 6.7-10s6.7.6 6.7 10.2zm-7.6 0c0 6 .1 6.5.9 6.5s.9-.7.9-6.5c0-5.5 0-6.1-.9-6.1s-.9.5-.9 6.1zm19.9-5.1h-5.6c0 .6-.1 1.6-.2 2.7.8-.7 1.9-1 2.9-1 3.4 0 4.2 2.9 4.2 6.6 0 5.3-2 7.4-6.7 7.4-5.5 0-6.3-3.5-6.3-6.1h5.4c0 1.6.2 2.2.9 2.2s.9-.4.9-3-.2-3.1-.9-3.1-.8.4-.9 1.6l-5.1-.3c.1-1.9.6-9.1.8-11.6h11.4l-.8 4.6z",
    style: {
      mask: "url(#i_2_)",
      fill: "#111a22"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M498.4 219.9c0 2.7-12.1 4.8-27 4.8s-27-2.2-27-4.8 12.1-4.9 27-4.9 27 2.3 27 4.9z",
    className: "st4"
  })), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M1 1h1L1 2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M1 1h1L1 2z"
  }))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M-1-1h-1l1-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_",
    style: {
      clipPath: "url(#SVGID_17_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    width: 27.2,
    height: 20.7,
    x: 456,
    y: 179,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "g_6_",
    width: 27.2,
    height: 20.7,
    x: 456,
    y: 179,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_18_)",
      mask: "url(#g_6_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    width: 27.2,
    height: 20.7,
    x: 456,
    y: 179,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "j_2_",
    width: 27.2,
    height: 20.7,
    x: 456,
    y: 179,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.4 189.2c0 10.1-4.1 10.5-6.8 10.5s-6.6-.3-6.6-10.6c0-9.6 4.2-10 6.7-10s6.7.4 6.7 10.1zm-7.6 0c0 5.9.1 6.5.9 6.5s.9-.7.9-6.5c0-5.5 0-6.1-.9-6.1s-.9.5-.9 6.1zm8.3-4.3c.1-2.4.9-5.9 6.4-5.9 4.1 0 6.2 1.9 6.2 5.2 0 2.6-1.2 3.8-2.5 4.3v.1c1.9.6 3.2 2.5 3 4.6 0 3.9-1.5 6.4-6.8 6.4s-6.3-2.9-6.4-6h5.4c0 1.5.1 2.2.9 2.2s.9-.7.9-2.2c0-2.5-.4-3-2.1-3h-1.3v-3.8h1.3c1.5 0 2.1-.2 2.1-2.2 0-1.5-.2-1.9-.8-1.9s-.8.8-.8 2.1l-5.5.1z",
    style: {
      mask: "url(#j_2_)",
      fill: "#111a22"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.8,
    cy: 223.1,
    className: "st4",
    rx: 19.8,
    ry: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.3 184c-3-4.4-8.1-7.9-16.5-7.9s-13.5 3.5-16.5 7.9c-5.1 7.5-4.2 17.5 2.1 24.1l14.5 15.2 14.5-15.2c6.1-6.6 7-16.6 1.9-24.1zm-16.5 20.4c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z",
    style: {
      fill: "#1935bf"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.1 219.9c0 2.7-12.1 4.8-27 4.8s-27-2.2-27-4.8 12.1-4.9 27-4.9 27 2.3 27 4.9z",
    className: "st4"
  })), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M1 1h1L1 2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M1 1h1L1 2z"
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M-1-1h-1l1-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_",
    style: {
      clipPath: "url(#SVGID_23_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    width: 27.7,
    height: 20.6,
    x: 172,
    y: 179.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "g_8_",
    width: 27.7,
    height: 20.6,
    x: 172,
    y: 179.1,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_24_)",
      mask: "url(#g_8_)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    width: 27.7,
    height: 20.6,
    x: 172,
    y: 179.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "k_2_",
    width: 27.7,
    height: 20.6,
    x: 172,
    y: 179.1,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.4 189.2c0 10.1-4.1 10.5-6.8 10.5s-6.6-.3-6.6-10.6c0-9.6 4.2-10 6.7-10s6.7.4 6.7 10.1zm-7.6 0c0 5.9.1 6.5.9 6.5s.9-.7.9-6.5c0-5.5 0-6.1-.9-6.1s-.9.5-.9 6.1zm15 10.1v-4h-6.5v-4.2l3.8-11.6h8.2V191h1.4l-.4 4.3h-1v4h-5.5zm0-9.5c0-2 .2-5.1.2-6.4-.5 2.3-1.4 5.9-1.9 7.6h1.6l.1-1.2z",
    style: {
      mask: "url(#k_2_)",
      fill: "#111a22"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4 223.1c0 2.2-8.9 4-19.8 4s-19.8-1.8-19.8-4 8.9-4 19.8-4 19.8 1.8 19.8 4z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.1 183.9c-3-4.4-8.1-7.9-16.5-7.9s-13.5 3.5-16.5 7.9c-5.1 7.5-4.2 17.5 2.1 24.1l14.5 15.2L147 208c6.3-6.5 7.2-16.5 2.1-24.1zm-16.5 20.5c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z",
    style: {
      fill: "#be2793"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M430.1 99.9c0 2.7-12.1 4.8-27 4.8s-27-2.2-27-4.8 12.1-4.8 27-4.8 27 2.1 27 4.8z",
    className: "st4"
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M1 1h1L1 2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M1 1h1L1 2z"
  }))), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M-1-1h-1l1-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_",
    style: {
      clipPath: "url(#SVGID_29_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    width: 27.1,
    height: 20.7,
    x: 388.7,
    y: 59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "g_10_",
    width: 27.1,
    height: 20.7,
    x: 388.7,
    y: 59,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_30_)",
      mask: "url(#g_10_)"
    }
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    width: 27.1,
    height: 20.7,
    x: 388.7,
    y: 59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "l_2_",
    width: 27.1,
    height: 20.7,
    x: 388.7,
    y: 59,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.1 69.2c0 10.1-4.1 10.5-6.8 10.5s-6.6-.3-6.6-10.7c0-9.6 4.2-10 6.7-10s6.7.5 6.7 10.2zm-7.6-.1c0 6 .1 6.5.9 6.5s.9-.7.9-6.5c0-5.5 0-6.1-.9-6.1s-.9.5-.9 6.1zm8.5 10.2V79c0-4.2 1.1-6.1 4.3-9.7 1.9-2.2 2.3-2.6 2.3-4.7 0-.8 0-1.5-.7-1.5s-.9.7-.9 2.8h-5.2c0-3.3 1-6.8 6.4-6.8 4.7 0 6.2 2.7 6.2 6 0 2.6-.8 4-3.2 6.7-1 .9-1.8 1.9-2.4 3.1h6l-.6 4.5-12.2-.1z",
    style: {
      mask: "url(#l_2_)",
      fill: "#111a22"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370 101.4c0 2.2-8.9 4-19.8 4s-19.8-1.8-19.8-4 8.9-4 19.8-4 19.8 1.8 19.8 4z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.7 62.3c-3-4.4-8.1-8-16.5-8s-13.5 3.5-16.5 8c-5.1 7.5-4.2 17.5 2.1 24.1l14.5 15.2 14.5-15.2c6.1-6.6 7-16.6 1.9-24.1zm-16.5 20.4c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10z",
    style: {
      fill: "#d75629"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M472.1 399.7h202.6c5.4 0 9.7 4.3 9.7 9.7v54.8c0 5.4-4.3 9.7-9.7 9.7H472.1c-5.4 0-9.7-4.3-9.7-9.7v-54.8c0-5.3 4.3-9.7 9.7-9.7z",
    className: "st24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M674 470.1H472.7c-3.6 0-6.5-2.9-6.5-6.5V410c0-3.6 2.9-6.5 6.5-6.5H674c3.6 0 6.5 2.9 6.5 6.5v53.6c0 3.6-2.9 6.5-6.5 6.5z",
    className: "st1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M535.3 426.2v6.8h-5v-17.5h6.6c3.6 0 5.1 1.7 5.1 4.8 0 2.3-.8 3.5-2.2 4 1.5.5 2.1 1.7 2.1 4.1v.4c0 1.7 0 3.6.1 4.1h-5c-.2-1.5-.2-3-.2-4.4v-.5c0-1.6-.2-1.9-1.1-1.9l-.4.1zm0-3.5h.3c.9 0 1.2-.2 1.2-1.9 0-1.4-.2-1.7-1.1-1.7h-.4v3.6zm19.7 1.5c0 6.2-1.6 9.2-6.5 9.2-4.5 0-6.1-3.1-6.1-9.3 0-5.8 1.6-8.9 6.3-8.9s6.3 3 6.3 9zm-7-.1c0 5 .1 5.5.8 5.5s.8-.6.8-5.5c0-4.7-.1-5.2-.8-5.2s-.9.5-.8 5.2zm12.3 5.9-.3 3h-5.1l2.4-17.5h7.9l2.5 17.5h-5.3l-.3-3h-1.8zm1.4-4.1c-.1-1.5-.3-5.2-.4-6.5h-.2c-.1 1.8-.4 5-.4 6.5h1zm6.5-10.3h5.5c4.5 0 6.6 2 6.6 8.4 0 6.7-2.1 9.1-6.6 9.1h-5.5v-17.5zm5.1 13.9h.3c1.1 0 1.2-.6 1.2-5.7 0-4.2-.2-4.6-1.2-4.6h-.3v10.3zm18.2-.8c0-2.3 0-6.3.1-8.5h-.2c-.4 4.1-.9 10.6-1.1 12.9h-3.6c-.3-3.3-.8-9.1-1.1-12.9h-.2c0 2.1.1 5.4.1 8.5v4.4h-4.3v-17.4h6.7c.2 1.7.5 6 .7 8.1h.2c.3-2.8.4-4.7.8-8.1h6.8v17.5h-4.7l-.2-4.5zM602 430l-.3 3h-5.1l2.4-17.5h7.9l2.5 17.5h-5.3l-.3-3H602zm1.4-4.1c-.1-1.5-.3-5.2-.4-6.5h-.2c-.1 1.8-.4 5-.4 6.5h1zm6.4-10.3h6.3c3.2 0 5.3 1.6 5.3 5.3 0 4-1.8 5.6-5.4 5.6h-1.2v6.5h-5v-17.4zm5 7.2h.4c.9 0 1.1-.4 1.1-1.9s-.4-1.8-1.1-1.8h-.3v3.7h-.1zm-93.9 18.3v17.5h-5.1v-17.5h5.1zm1.3 17.5v-17.5h5.4c1.4 6.6 1.9 8.8 2 9.4h.2c-.2-2.5-.4-6-.4-8.4v-1h4.5v17.5h-5.5c-1.5-7.9-1.7-9.3-1.9-10h-.2c.2 2 .4 6.6.4 9v1h-4.5zm13-17.5h9.9v3.8h-4.8v3h4.5v3.9h-4.5v6.8h-5.1v-17.5zm22.9 8.7c0 6.2-1.6 9.2-6.5 9.2-4.5 0-6.1-3.1-6.1-9.3 0-5.8 1.6-8.9 6.3-8.9s6.3 3 6.3 9zm-7.1-.1c0 5 .1 5.5.8 5.5s.8-.6.8-5.5c0-4.7-.1-5.2-.8-5.2s-.8.4-.8 5.2zm20.2 8.9h-3.6c-.1-.4-.1-.9-.1-1.3-.7 1.2-2 1.8-3.4 1.7-3.2 0-5.2-1.7-5.2-9 0-7.8 2.7-9.2 6.5-9.2 5.1 0 5.7 3.5 5.8 5.4H566c0-1.1-.1-1.7-.7-1.7s-.9.7-.9 5.5c0 4.6.2 5.2.8 5.2s.8-.9.8-1.9V452h-.8v-3.6h6v10.2zm6.1-6.8v6.8h-5v-17.5h6.6c3.6 0 5.1 1.7 5.1 4.9 0 2.2-.8 3.5-2.2 4 1.5.5 2.1 1.7 2.1 4.1v.4c0 1.7 0 3.7.1 4.1h-5c-.2-1.5-.2-3-.2-4.4v-.5c0-1.6-.2-1.9-1.1-1.9h-.4zm0-3.5h.3c.9 0 1.2-.2 1.2-1.9 0-1.4-.2-1.7-1.1-1.7h-.4v3.6zm12.3 7.3-.3 3h-5.1l2.4-17.5h7.9l2.5 17.5h-5.3l-.3-3h-1.8zm1.4-4.2c-.1-1.5-.3-5.2-.4-6.6h-.2c-.1 1.8-.4 5-.4 6.6h1zm6.5-10.3h6.3c3.2 0 5.3 1.6 5.3 5.3 0 4-1.8 5.6-5.4 5.6h-1.2v6.5h-5.1l.1-17.4zm5 7.3h.4c.9 0 1.1-.5 1.1-1.9s-.4-1.8-1.1-1.8h-.3v3.7h-.1zm7.2-7.3h5.1v6.2h1.5v-6.2h5.2v17.5h-5.2v-7h-1.5v7h-5.1v-17.5zm18.2 0v17.5h-5.1v-17.5h5.1zm13 11.4c0 3.6-1.3 6.5-5.9 6.5-4.4 0-6.2-2.2-6.2-9.2 0-7.3 2.5-9 6.3-9 4.5 0 5.8 2.8 5.8 6h-5.2c0-1.7 0-2.3-.7-2.3s-.7.7-.7 5.2c0 4.8 0 5.6.7 5.6s.7-.9.7-2.8h5.2z",
    className: "st3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M674.7 466.7H472.1c-1.4 0-2.5-1.1-2.5-2.5v-54.8c0-1.4 1.1-2.5 2.5-2.5h202.6c1.4 0 2.5 1.1 2.5 2.5v54.8c-.1 1.4-1.2 2.5-2.5 2.5zm-202.6-58.5c-.7 0-1.2.5-1.2 1.2v54.8c0 .7.5 1.2 1.2 1.2h202.6c.7 0 1.2-.6 1.2-1.2v-54.8c0-.7-.6-1.2-1.2-1.2H472.1z",
    className: "st3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M484.1 473.9h12.8v12.8h-12.8v-12.8zm165.7 0h12.8v12.8h-12.8v-12.8z",
    className: "st24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M705.2 46.9c5-16.9-4.7-34.7-21.6-39.8-16.9-5-34.7 4.7-39.8 21.6-1.8 5.9-1.8 12.2 0 18.2h61.4z",
    className: "st8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M588 46.9s6-16.1 16.1-15.4c10.1.7 16.4 8.6 23.9 7.3s9.4-13 20-14.3 14.8 14 22.1 14.3 7.5-8.1 19.8-7.5 18 15.6 18 15.6H588zM197.9 21.4c-4.2-6.8-12.1-21.5-23-20.1s-12.3 10.5-20.1 11.8-14.2-6.7-24.6-7.5-16.6 15.8-16.6 15.8h84.3z",
    className: "st3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.9,
    cy: 42,
    className: "st25",
    rx: 12.6,
    ry: 1.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m324.7 31.9-16.8-.2c-1.6 0-2.8-1.3-2.8-2.8v-.2c.4-5.2 1.4-7.5 2.6-11.1 2.3-6 5.1-11.7 8.4-17.1.1-.2.3-.3.5-.4.2.1.4.2.5.4 3.2 5.5 5.9 11.3 8 17.3 1.2 3.6 2.1 6 2.4 11.1 0 1.6-1.2 2.9-2.7 2.9l-.1.1z",
    className: "st1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M316.1 13.2c.2 9.6-.1 19.1-.1 28.7 0 .2.2.3.4.3s.3-.2.3-.3c0-9.6.2-19.1.1-28.7 0-.2-.2-.3-.4-.3l-.3.3z",
    className: "st26"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M321 21.4c-.3 2.2-1.4 5.6-4.3 4.9-.5-.1-.7.6-.2.7 3.5.8 5-2.9 5.3-5.7 0-.4-.7-.4-.8.1z",
    className: "st26"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M200.4 465.2c0 .9-5.7 1.7-12.6 1.7s-12.6-.8-12.6-1.7 5.6-1.7 12.6-1.7 12.6.8 12.6 1.7z",
    className: "st25"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m200.6 455.2-16.7-.2c-1.6 0-2.8-1.3-2.8-2.9v-.1c.4-5.2 1.4-7.5 2.6-11.1 2.3-6 5.1-11.7 8.4-17.2.1-.2.3-.3.5-.4.2.1.4.2.5.4 3.2 5.5 5.9 11.3 8 17.3 1.2 3.6 2.1 6 2.4 11.1.1 1.6-1.1 2.9-2.7 3-.1.1-.2.1-.2.1z",
    className: "st1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M192 436.5c.2 9.6-.1 19.1-.1 28.7 0 .2.2.3.4.3s.3-.2.3-.3c0-9.6.2-19.1.1-28.7 0-.2-.2-.3-.4-.3-.1.1-.3.2-.3.3z",
    className: "st26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.9 444.7c-.3 2.2-1.4 5.6-4.3 5-.5-.1-.7.6-.2.7 3.5.8 5-2.9 5.3-5.7 0-.5-.8-.5-.8 0z",
    className: "st26"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 728.7,
    cy: 95.2,
    className: "st25",
    rx: 11.5,
    ry: 1.7
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 721.9,
    cy: 67.6,
    className: "st1",
    rx: 11.1,
    ry: 16.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M727.1 67.3c-.3 3.4-2.3 6.4-5.2 8.1-.2.1-.2.4-.1.5.1.1.3.2.4.1 3.2-1.9 5.2-5.1 5.6-8.8 0-.3-.7-.3-.7.1z",
    className: "st26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M721.4 65.1c.2 10.1.2 20.1.2 30.2 0 .2.2.3.4.3s.3-.2.3-.3c0-10.1 0-20.1-.2-30.2 0-.2-.2-.3-.4-.3-.1 0-.2.1-.3.3z",
    className: "st26"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7,
    cy: 218.6,
    className: "st25",
    rx: 11.5,
    ry: 1.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7,
    cy: 191,
    className: "st1",
    rx: 11.1,
    ry: 16.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9 190.7c-.3 3.4-2.3 6.4-5.2 8.1-.2.1-.2.4-.1.5s.3.2.4.1c3.2-1.9 5.2-5.1 5.6-8.8 0-.4-.7-.4-.7.1z",
    className: "st26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 188.5c.2 10.1.2 20.1.2 30.2 0 .2.2.3.4.3s.3-.2.3-.3c0-10.1 0-20.1-.2-30.2 0-.2-.2-.3-.4-.3-.1 0-.2.1-.3.3z",
    className: "st26"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.3,
    cy: 465.1,
    className: "st25",
    rx: 11.5,
    ry: 1.7
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.3,
    cy: 437.4,
    className: "st1",
    rx: 11.1,
    ry: 16.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M730.5 437.2c-.3 3.4-2.3 6.4-5.2 8.1-.2.1-.2.4-.1.5.1.1.3.2.4.1 3.2-1.9 5.2-5.1 5.6-8.8.1-.4-.7-.4-.7.1z",
    className: "st26"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M724.9 434.9c.2 10.1.2 20.1.2 30.2 0 .2.2.3.4.3s.3-.2.3-.3c0-10.1 0-20.1-.2-30.2 0-.2-.2-.3-.4-.3s-.3.1-.3.3z",
    className: "st26"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.3,
    cy: 447.9,
    className: "st25",
    rx: 11.6,
    ry: 1.7
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.3,
    cy: 420.2,
    className: "st1",
    rx: 11.1,
    ry: 16.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 420c-.3 3.4-2.3 6.4-5.2 8.1-.2.1-.2.3-.1.5s.3.2.5.1c3.2-1.9 5.2-5.1 5.6-8.8-.1-.4-.8-.4-.8.1z",
    className: "st26"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M244.8 417.7c.2 10.1.2 20.1.2 30.2 0 .2.2.3.4.3s.3-.2.3-.3c0-10.1-.1-20.1-.2-30.2 0-.2-.2-.3-.4-.3-.1 0-.2.1-.3.3z",
    className: "st26"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8 36.1c0 1.6-14.3 2.9-32 2.9s-32-1.3-32-2.9 14.3-2.9 32-2.9 32 1.3 32 2.9z",
    className: "st25"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 36.1s3.4-11 9.5-10.5 3 .9 7.2 2 5.2-6.6 10.9-6.7c7.6-.1 9.1 6.8 12.1 6.8s4.3-4.4 9.2-2 6.2 10.4 6.2 10.4H23.6z",
    className: "st1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 180.5c0 1.6-14.3 2.9-32 2.9s-32-1.3-32-2.9 14.3-2.9 32-2.9 31.9 1.3 32 2.9z",
    className: "st25"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53 180.5s3.4-10.9 9.5-10.5 3 .9 7.2 2 5.2-6.6 10.9-6.7c7.6-.1 9.1 6.7 12.1 6.7s4.2-4.4 9.2-2 6.3 10.5 6.3 10.5H53z",
    className: "st1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M360 429.2c0 1.6-14.4 2.9-32 2.9s-32-1.3-32-2.9 14.3-2.9 32-2.9 32 1.2 32 2.9z",
    className: "st25"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M304.8 429.2s3.4-11 9.5-10.5 3 .9 7.2 2 5.2-6.6 10.9-6.7c7.6-.1 9.1 6.7 12.1 6.7s4.3-4.4 9.2-2 6.3 10.4 6.3 10.4l-55.2.1zM353 42.8s-6.4-9.3-4-10.6 6.4 8.5 6.4 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.9-.1z",
    className: "st1"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.1,
    cy: 42.9,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 297s-6.4-9.3-4-10.6 6.3 8.5 6.3 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.8-.1z",
    className: "st1"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.8,
    cy: 297.1,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 72.9s-6.4-9.3-4-10.6 6.4 8.4 6.4 8.4.2-7.2 3.5-7.6-1 9.8-1 9.8h-4.9z",
    className: "st1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 73.1c0 .4-3 .7-6.7.7s-6.6-.3-6.6-.7 3-.7 6.7-.7 6.6.3 6.6.7z",
    className: "st25"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M634.7 312.8s-6.4-9.3-4-10.6 6.3 8.5 6.3 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.8-.1z",
    className: "st1"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.8,
    cy: 313,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M533.5 30.6s-6.4-9.3-4-10.6 6.4 8.5 6.4 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.9-.1z",
    className: "st1"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.7,
    cy: 30.8,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8 472.3s-6.4-9.3-4-10.6 6.4 8.5 6.4 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.9-.1z",
    className: "st1"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146,
    cy: 472.5,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M368 182.5s-6.4-9.3-4-10.6 6.4 8.4 6.4 8.4.2-7.2 3.5-7.6-1 9.8-1 9.8H368z",
    className: "st1"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.1,
    cy: 182.7,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M433 472.7s-6.4-9.3-4-10.6 6.4 8.5 6.4 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.9-.1z",
    className: "st1"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.2,
    cy: 472.8,
    className: "st25",
    rx: 6.7,
    ry: 0.7
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M700.4 421.7s-6.4-9.3-4-10.6 6.4 8.5 6.4 8.5.2-7.2 3.5-7.6-1 9.8-1 9.8l-4.9-.1z",
    className: "st1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M708.2 421.9c0 .4-3 .7-6.7.7s-6.7-.3-6.7-.7 3-.7 6.7-.7 6.7.3 6.7.7z",
    className: "st25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.2 24.2c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.6-3.8-1.4zm9.3 1.1c0-.5 1-.9 2.3-.9s2.3.4 2.4.8-1 .9-2.3.9-2.4-.4-2.4-.8z",
    className: "st1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.9 171.5c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.7-.6-3.8-1.4zm9.4 1.1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.3-2.3-.8z",
    className: "st1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8 295.2c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.6-3.8-1.4zm9.3 1.1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.4-2.3-.8z",
    className: "st1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.2 435.9c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.6-3.8-1.4zm9.3 1.1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.3-2.3-.8z",
    className: "st1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.7 308.5c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.7-3.8-1.4zm9.3 1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.3-2.3-.8z",
    className: "st1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6 461.4c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.7-3.8-1.4zm9.3 1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.3-2.3-.8z",
    className: "st1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6 9.1c0-.8 1.7-1.4 3.8-1.4s3.8.6 3.8 1.4-1.7 1.4-3.8 1.4-3.8-.6-3.8-1.4zm9.3 1c0-.5 1-.9 2.3-.9s2.3.4 2.3.8-1 .9-2.3.9-2.3-.3-2.3-.8z",
    className: "st1"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M746.8 299.8c-4.2-6.8-12.2-21.5-23-20.1s-12.3 10.5-20.1 11.9-14.2-6.7-24.6-7.5-16.6 15.8-16.6 15.8l84.3-.1z",
    className: "st3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.35c7e2e6.svg";
export { ForwardRef as ReactComponent };